import { Component, OnInit, forwardRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavController, NavParams, ModalController, IonicModule } from '@ionic/angular';
import { BuscarPessoaPage } from '../../buscar-pessoa/buscar-pessoa.page';
import { GrupoProvider } from 'src/app/services/grupo/grupo';
import { CommonModule } from '@angular/common';


import { TranslateModule } from '@ngx-translate/core';
import { ImagePipe } from 'src/app/pipes/image/image';

@Component({
  selector: 'app-grupo-adm-hierarquia-add',
  templateUrl: './grupo-adm-hierarquia-add.page.html',
  styleUrls: ['./grupo-adm-hierarquia-add.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    ReactiveFormsModule
  ],
})
export class GrupoAdmHierarquiaAddPage implements OnInit {
  vincularPessoa: boolean = false;
  validations_form: FormGroup;
  funcao: any = {};
  idGrupo: any;
  pessoa: any = {};

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public modalCtrl: ModalController,
    public grupoProvider: GrupoProvider,
  ) {

    this.validations_form = this.formBuilder.group({
      mostrarReuniao: new FormControl(false),
      exibirAppPortal: new FormControl(false)
    });

    this.idGrupo = this.navParams.get('idGrupo');
    this.funcao = this.navParams.get('funcao');
    if (this.funcao.hierarquiaGrupoFuncao) {
      this.pessoa = this.funcao.hierarquiaGrupoFuncao.pessoa;
      this.validations_form.controls['mostrarReuniao'].setValue(this.funcao.hierarquiaGrupoFuncao.mostrarReuniao == 1);
      this.validations_form.controls['exibirAppPortal'].setValue(this.funcao.hierarquiaGrupoFuncao.exibirAppPortal == 1);
    }
  }

  ngOnInit() {
  }

  async selecionarPessoa() {
    var dataPessoa = { 'isVisitante': false, adiciona: true };
    var modalPessoa = await this.modalCtrl.create({ component: BuscarPessoaPage, componentProps: dataPessoa });
    modalPessoa.present();

    const pessoa = (await modalPessoa.onWillDismiss())
    if (pessoa.data) {
      this.pessoa = pessoa.data.pessoa;
    } else {
      this.vincularPessoa = false;
    }
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  onSubmit(dados: { idPessoa: any; pessoa: any; exibirAppPortal: string; mostrarReuniao: string; }) {
    dados.idPessoa = this.pessoa.id;
    dados.pessoa = this.pessoa;
    dados.exibirAppPortal = dados.exibirAppPortal ? '1' : '0';
    dados.mostrarReuniao = dados.mostrarReuniao ? '1' : '0';
    this.grupoProvider.salvarHierarquia(dados, this.idGrupo, this.funcao.id).subscribe(() => {
      this.modalCtrl.dismiss();
    });

  }

}
